import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import InsuranceDepositsAnalytics from '@/components/insurance-sub/InsuranceDepositsAnalytics';
import InsuranceDepositsRecords from '@/components/insurance-sub/InsuranceDepositsRecords';
import { Wallet } from 'lucide-react';

export default function InsuranceDeposits() {
    return (
        <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
            <div className="mb-8">
                <div className="flex items-center gap-3 mb-2">
                    <Wallet className="h-8 w-8" />
                    <h1 className="text-4xl font-semibold tracking-tight">Insurance Deposits</h1>
                </div>
                <p className="text-muted-foreground">What drivers paid toward their premiums.</p>
            </div>

            <Tabs defaultValue="analytics" className="space-y-6">
                <TabsList>
                    <TabsTrigger value="analytics">Analytics</TabsTrigger>
                    <TabsTrigger value="records">Records</TabsTrigger>
                </TabsList>

                <TabsContent value="analytics">
                    <InsuranceDepositsAnalytics />
                </TabsContent>

                <TabsContent value="records">
                    <InsuranceDepositsRecords />
                </TabsContent>
            </Tabs>
        </div>
    );
}
